import React, { useEffect, useMemo, useState } from 'react';
import RegistrationTestimonials from '../../containers/registration/RegistrationTestimonials';
import { routes } from '../../containers/routes/routes-names';
import { data, Link, useLocation, useNavigate } from 'react-router-dom';
import websitelogo from '../../assets/img/offerx-logo.svg';
import { Helmet } from 'react-helmet';
import SelectAccountType from './SelectAccountType';
import { Outlet } from 'react-router-dom';
import compDetails from '../../assets/img/comp-details.png';
// import candiDetails from '../../assets/img/candi-details.png';
import candiDetails from '../../assets/img/Candidate-ver.svg';
import SignUpHeader from './SignUpHeader';
import SignUpBackButton from './SignUpBackButton';
import LeftPanelContent from './LeftPanelContent';
import SelectAuthType from './SelectAuthType';
import BasicDetails from './BasicDetails';
import SignUpPage from './SignUpPage';
import { useRegistration } from './RegistrationContext';
import CustomAuth from '../../containers/registration/custom-auth/CustomAuth';
import { localStorageGetItem, localStorageRemoveItem, localStorageSetItem } from '../storage/localStorageManager';
import { sessionStorageClearAll } from '../storage/sessionStorageManager';

export enum SignupTabs {
    ACCOUNT_TYPE = 'select-account-type',
    AUTH_TYPE = 'select-auth-type',
    BASIC_DETAILS = 'basic-details',
    SIGNUP_FORM = 'signup-form',
    CUSTOM_AUTH = 'customAuth',
}

type Props = {
    candidateId?: string;
    managerId?: string;
};

const SignupLayout: React.FC<Props> = ({ candidateId, managerId }) => {
    // const [activeTab, setActiveTab] = useState(SignupTabs.ACCOUNT_TYPE);
    const [showTestimonial, setShowTestimonial] = useState(true);
    const [currentUnclaimedId, setCurrentUnclaimedId] = useState<string>('');

    const {
        signAs,
        activeTab,
        setActiveTab,
        candidateType,
        showPasswordTab,
        setShowPasswordTab,
        ConfirmUnclaimedCandidateInvitationId,
        unclaimedData,
        resetAllState,
        setCheckIcon,
        setCandidateType,
    } = useRegistration();

    const { pathname } = useLocation();
    const location = useLocation();

    const tabs = [
        {
            key: SignupTabs.ACCOUNT_TYPE,
            component: <SelectAccountType />,
        },
        {
            key: SignupTabs.AUTH_TYPE,
            component: <SelectAuthType />,
        },
        {
            key: SignupTabs.CUSTOM_AUTH,
            component: <CustomAuth />,
        },
        {
            key: SignupTabs.BASIC_DETAILS,
            component: <BasicDetails />,
        },
        {
            key: SignupTabs.SIGNUP_FORM,
            component: <SignUpPage />,
        },
    ];

    const clearAllSignupData = () => {
        localStorageRemoveItem('Email');
        localStorageRemoveItem('isOtpVerified');
        localStorageRemoveItem('otpToken');
        localStorageRemoveItem('requestId');
        sessionStorageClearAll();
        resetAllState();
    };

    const getUnclaimedIdentifier = (data: any) => {
        if (!data) return '';
        return `${data.id || data.companyId || ''}_${data.navigationTimestamp || ''}`;
    };

    useEffect(() => {
        const incomingData = location.state?.data;

        if (incomingData) {
            const newIdentifier = getUnclaimedIdentifier(incomingData);

            if (currentUnclaimedId && currentUnclaimedId !== newIdentifier) {
                clearAllSignupData();
                localStorageRemoveItem('unclaimed');
                setActiveTab(SignupTabs.ACCOUNT_TYPE);
            }
            if (newIdentifier !== currentUnclaimedId) {
                localStorageSetItem('unclaimed', incomingData, false);
                setCurrentUnclaimedId(newIdentifier);
                if (incomingData.claimedType === 'company') {
                    setCheckIcon('company');
                    setCandidateType('company');
                    setActiveTab(SignupTabs.ACCOUNT_TYPE);
                } else {
                    setActiveTab(SignupTabs.ACCOUNT_TYPE);
                }
            }
        } else if (currentUnclaimedId) {
            clearAllSignupData();
            localStorageRemoveItem('unclaimed');
            setCurrentUnclaimedId('');
            setActiveTab(SignupTabs.ACCOUNT_TYPE);
        }
    }, [location.state?.data]);

    useEffect(() => {
        if (pathname !== '/signup') {
            setCurrentUnclaimedId('');
        }
    }, [pathname]);

    useEffect(() => {
        if (activeTab === SignupTabs.SIGNUP_FORM) {
            setShowTestimonial(false);
        } else {
            setShowTestimonial(true);
        }
    }, [activeTab]);

    return (
        <>
            {pathname === '/signup' && (
                <>
                    <Helmet>
                        <title>
                            OfferX - Sign Up | Be A Part Of The Modern Hiring Process Without Candidate Backout
                        </title>
                        <meta
                            name="description"
                            content="Embrace a world of boundless career possibilities by creating an OfferX account. Build your profile, upload your resume, and embark on connecting with top employers in your industry."
                        />
                    </Helmet>

                    <SignUpHeader />

                    <div className="container">
                        <SignUpBackButton
                            activeTab={activeTab}
                            candidateType={candidateType}
                            setActiveTab={setActiveTab}
                            setShowPasswordTab={setShowPasswordTab}
                            showPasswordTab={showPasswordTab}
                            ConfirmUnclaimedCandidateInvitationId={ConfirmUnclaimedCandidateInvitationId}
                            resetAllState={resetAllState}
                            unclaimedData={unclaimedData}
                        />

                        <div className="row screen-height d-flex align-items-center ms-lg-2  ms-md-2 ms-0">
                            <LeftPanelContent showTestimonial={showTestimonial} signAs={signAs} />
                            <div className="col-lg-5 order-lg-2 order-md-2 order-1">
                                <div className="">
                                    <div className="col-md-12">
                                        <div className="tab-content" id="nav-tabContent">
                                            <div className="tab-pane fade show active" id="nav-home" role="tabpanel">
                                                <div className="mx-auto d-block" style={{ maxWidth: '500px' }}>
                                                    {tabs.find((item) => item.key === activeTab)?.component}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default SignupLayout;
